import { DotLottie } from '@lottiefiles/dotlottie-web';
import $ from 'jquery';

const animationCanvases = $('.js-lottie-animations');
animationCanvases.each((index, item) => {
    const animationName = $(item).data('animation-name');
    item._lottieAnimation = new DotLottie({
        autoplay: true,
        loop: true,
        canvas: item,
        src: `/static/animations/animation-${animationName}.json` // or .json file
    });
});

const resizeCanvases = () => {
    animationCanvases.each((index, item) => {
        item._lottieAnimation.resize();
    });
};

$(window).on('resize', resizeCanvases);
